
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import latin from "../../assets/latin.jpg";

function LatinMagyar({handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Latin magyar fordító</title>
                <meta name='description' content="Ingyenes latin magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Latin magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/latin-magyar-fordito" />
            </Helmet>
            <h1>Latin magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A latin nyelvről</h2>
                    <img src={latin} alt="Latin zászló"></img>

                </div>

                <p>A latin vagy Lingua Latina egy ősi nyelv, amelyet a rómaiak beszéltek és a Római Birodalom nyelveként használtak. Az indoeurópai nyelvcsalád italikus ágának része, és jelentős hatással volt számos modern európai nyelv fejlődésére.</p>

<p>A klasszikus latin, más néven cicerói latin, a nyelv irodalmi és formális változata volt, amelyet olyan híres írók használtak, mint Cicero, Vergilius és Julius Caesar. A római köztársaság és birodalom idején a jog, a kormányzás és az oktatás nyelve volt.</p>

<p>A latin nyelvtana erősen flektált, kiterjedt főnévi és igei deklinációval. A főneveknek különböző nemű, számú és esetű alakjai vannak, míg az igék az idő, a mód, a hangnem és a személy szerint konjugálódnak. A latin szórend viszonylag rugalmas, mivel a jelentés elsősorban a szavak ragozásán és végződésén keresztül jut kifejezésre.</p>

<p>A latin ábécé számos modern írásrendszer alapja. Ez 23 betűből áll, köztük a jól ismert A, B, C és így tovább. A latin kiejtés történelmi koronként és régiótól függően változik, de ma általában a rekonstruált klasszikus kiejtést tanítják.</p>

<p>A latin nyelv jelentős mértékben hozzájárult különböző területekhez, többek között az irodalomhoz, a filozófiához, a joghoz és a tudományhoz. Számos tudományos, orvosi és jogi kifejezés gyökere a latinban gyökerezik, és a latin kifejezéseket és kifejezéseket ma is használják tudományos és jogi kontextusban.</p>

<p>A nyelv tanulása a klasszikus irodalom mélyebb megértését teszi lehetővé, és hozzáférést biztosít a befolyásos római szerzők műveihez. Emellett javítja az ókori Róma történelmi és kulturális kontextusának megértését, beleértve a mítoszokat, a történelmet és a politikai struktúrákat.</p>

<p>A latin nyelvet továbbra is a katolikus egyház nyelveként használják, az egyházi latin a vallási szövegek és szertartások standard formája. A latin nyelvet más nyelvek, különösen az olasz, a francia, a spanyol és a portugál román nyelvek szókincsének, nyelvtanának és nyelvi elemzésének fejlesztéséhez is tanulják.</p>

                </section>
        </>

    )
}

export default LatinMagyar;